import { useLanguage } from "@/contexts/LanguageContext";
import trendUpIcon from "@/assets/Icons/Trend_up.png";
import paletteIcon from "@/assets/Icons/Paint_Palette.png";
import handshakeIcon from "@/assets/Icons/Handshake.png";
import chartIcon from "@/assets/Icons/Chart.png";

const WhyFulltrui = () => {
  const { t } = useLanguage();
  
  const benefits = [
    {
      icon: chartIcon,
      title: t.WhyFulltrui.benefits.subtle.title,
      description: t.WhyFulltrui.benefits.subtle.description,
    },
    {
      icon: paletteIcon,
      title: t.WhyFulltrui.benefits.tailored.title,
      description: t.WhyFulltrui.benefits.tailored.description,
    },
    {
      icon: handshakeIcon,
      title: t.WhyFulltrui.benefits.harmony.title,
      description: t.WhyFulltrui.benefits.harmony.description,
    },
    {
      icon: trendUpIcon,
      title: t.WhyFulltrui.benefits.scalable.title,
      description: t.WhyFulltrui.benefits.scalable.description,
    },
  ];
  return (
    <section className="py-24 md:py-32 bg-accent">
      <div className="container px-6 md:px-8">
        <div className="max-w-4xl mx-auto">
          {/* Header */}
          <div className="text-center mb-16 animate-fade-in">
            <h2 className="mb-6">
              {t.WhyFulltrui.title}
            </h2>
          </div>

          {/* Benefits Grid */}
          <div className="grid md:grid-cols-2 gap-8 md:gap-12">
            {benefits.map((benefit, index) => (
                <div
                  key={index}
                  className="flex gap-4 animate-fade-in-up"
                  style={{ animationDelay: `${index * 0.1}s` }}
                >
                  <div className="flex-shrink-0">
                      <img src={benefit.icon} alt={benefit.title} className="w-24 h-24" />
                  </div>
                  <div>
                    <h3 className="text-xl md:text-2xl mb-2 font-semibold">
                      {benefit.title}
                    </h3>
                    <p className="text-muted-foreground leading-relaxed">
                      {benefit.description}
                    </p>
                  </div>
                </div>
              ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyFulltrui;
